import { useEffect } from "react"

const useStorageListener = (callback: () => void) => {
  useEffect(() => {
    window.addEventListener('storage', callback, { passive: true })
    return () => {
      window.removeEventListener('storage', callback)
    }
  }, [callback])
}

export default useStorageListener;